import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import SystemLogger from '../../Services/SystemLogger'

export const RouteChangeLogger = () => {
	const location = useLocation()

	useEffect(() => {
		SystemLogger.logEvent('navigation', 'page-view', {
			data: { path: location.pathname, search: location.search },
		})
	}, [location.pathname, location.search])

	return null
}

export default RouteChangeLogger
